module.exports = __webpack_public_path__ + "media/images/search-icons/article-ad1da63a49ad23399121a72bfe26a70d.png";